import { ApiError, convertObjectToJson } from '@gorila-shared-ui/components';
import { del, get, post } from 'aws-amplify/api';
import { downloadData, getUrl, uploadData } from 'aws-amplify/storage';
import { environment } from '../environments/environment';
import { getErrorMessage } from '../utils/apiErrorResponse';

export const getRequest = async (path: string, params = {}): Promise<{ data?: any; error?: ApiError }> => {
  try {
    const response = await get({
      apiName: environment.awsAPIEndpointName,
      path,
      options: {
        ...convertObjectToJson(params),
      },
    }).response;
    return {
      data: await response.body.json(),
    };
  } catch (error) {
    console.log(error);
    return {
      error: getErrorMessage(error, { params, path }),
    };
  }
};

export const postRequest = async (path: string, params = {}): Promise<{ data?: any; error?: ApiError }> => {
  try {
    const response = await post({
      apiName: environment.awsAPIEndpointName,
      path,
      options: {
        ...convertObjectToJson(params),
      },
    }).response;
    try {
      return {
        data: await response.body?.json(),
      };
    } catch {
      return {
        data: undefined,
      };
    }
  } catch (error) {
    console.log(error);
    return {
      error: getErrorMessage(error, { params, path }),
    };
  }
};

export const fileRequest = async (key: string) => {
  try {
    return {
      data: {
        url: (await getUrl({ key })).url,
      },
    };
  } catch (error) {
    console.log(error);
    return {
      error: getErrorMessage(error),
    };
  }
};

export const uploadRequest = async (key: string, file: File, options = {}) => {
  try {
    return {
      data: {
        key: (await uploadData({ key, data: file, options }).result).key,
      },
    };
  } catch (error) {
    console.log(error);
    return {
      error: getErrorMessage(error),
    };
  }
};

export const downloadRequest = async (key: string) => {
  try {
    return {
      data: {
        file: (await downloadData({ key }).result).body,
      },
    };
  } catch (error) {
    console.log(error);
    return {
      error: getErrorMessage(error),
    };
  }
};

export const deleteRequest = async (path: string, params = {}): Promise<{ data?: any; error?: ApiError }> => {
  try {
    return {
      data: await del({
        apiName: environment.awsAPIEndpointName,
        path,
        options: {
          ...convertObjectToJson(params),
        },
      }).response,
    };
  } catch (error) {
    console.log(error);
    return {
      error: getErrorMessage(error, { params, path }),
    };
  }
};
